"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.combineEvent = exports.sendPayloadObject = exports.ReduxResponseColumns = void 0;
var ReduxResponseColumns;
(function (ReduxResponseColumns) {
    ReduxResponseColumns["PAYLOAD"] = "payload";
})(ReduxResponseColumns = exports.ReduxResponseColumns || (exports.ReduxResponseColumns = {}));
const sendPayloadObject = (columnName) => (state, action) => {
    return Object.assign(Object.assign({}, state), { [columnName]: action.payload });
};
exports.sendPayloadObject = sendPayloadObject;
/**
 * 組合 Reducer 特定事件和一般事件
 *
 * @param reducerEvent
 * @param basicEventList
 * @returns
 */
const combineEvent = (reducerEvent, basicEventList) => {
    const convertedBasicEventList = basicEventList.reduce((previousValue, currentValue) => (Object.assign(Object.assign({}, previousValue), { [currentValue]: (0, exports.sendPayloadObject)(ReduxResponseColumns.PAYLOAD) })), {});
    return Object.assign(Object.assign({}, reducerEvent), convertedBasicEventList);
};
exports.combineEvent = combineEvent;
